<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Update LocationID against ShipmentID </strong>           
          </div>
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="4">                             
                  <b-form-group label="Shipment Id"  :label-cols="4" >
                    <b-form-input class="input" type="text" name="shipmentid" v-model="data.shipmentid" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.shipmentid') }" placeholder="Enter shipment id ">
                    </b-form-input>
                    <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>             
                  </b-form-group> 
                </b-col>
                <b-col md="4"> 
                    <b-form-group label="Location ID"  :label-cols="4" >
                     <b-form-input class="input" title="Enter Location ID" type="text"  pattern="[0-9]*" minlength="6" maxlength="6" name="pincode" v-model="data.pincode" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.pincode') }" placeholder="Enter location id">
                    </b-form-input>
                    <span v-show="errors.has('form-1.pincode')" class="help text-danger">{{ errors.first('form-1.pincode') }}</span>            
                  </b-form-group> 
                </b-col>
                <b-col md="4">
                 <b-button class="mr-2" type="submit" size="md" variant="primary">Submit</b-button>
                 <b-button type="button" @click="clear" size="md" variant="danger">Clear</b-button> 
                </b-col>
              </b-row>           

            </form>
          </div>  
         

           <b-modal title="Confirmation Box" v-model="toggleInfo" size="sm" @ok="toggleInfoModal = false">
            <template slot="modal-header" slot-scope="{ close }">
            <h5>Update location against ShipmentID</h5>
            </template>
            <template slot="default" slot-scope="{ hide }">
              <form v-on:submit.prevent="toggleInfoModal(value)">
                <div class="modal-background"></div>
                <div class="modal-card">
                  <section class="modal-card-body">                          
                    <span>  Are you sure you want to update location id against this shipping Id {{data.shipmentid}}  ?</span>
                  </section>
                  <footer slot="modal-footer">
                    <b-button variant="primary" size="sm" type="submit">Ok</b-button>
                  </footer>
                </div>
              </form>
            </template>
            <footer slot="modal-footer" slot-scope="{ cancel }">
              <b-button size="sm" variant="danger" @click="closemodal">
                Cancel
              </b-button>
            </footer>
          </b-modal>

        </b-card>
      </b-col>    
    </b-row> 
</div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function () {
    return {
      name: 'UpdatepincodeagainAWB',
      data: {},
      toggleInfo: false
    }
  },
  created: function () {
  },
  methods: {
    validateForm  (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.toggleInfo = !this.toggleInfo
        }
      })
    },
    clear: function () {
      this.data = {}
      this.errors.clear('form-1')
      var searchlisting = document.getElementById('searchlisting')
      searchlisting.style.display = 'none'
    },
    toggleInfoModal: function () {
      const payload = {
        shippingid: this.data.shipmentid.toString(),
        pincode: this.data.pincode.toString()
      }
      this.$http.post(`${CONSTANTS.API_URL}/UpdatepincodeagainAWB`, payload)
        .then((result) => {
          Utils.notify(result.body,'success');
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      this.toggleInfo = !this.toggleInfo
    },
    closemodal: function () {
      // console.log('closemodal')
      this.toggleInfo = !this.toggleInfo
    }
  }
}
</script>

